import globalIP from '@/GlobelIP';
import React, { useDebugValue, useEffect, useState } from 'react';
import {
  Button,
  Col,
  Divider,
  FlexboxGrid,
  IconButton,
  Loader,
  Message,
  Modal,
  Panel,
  Stack,
  toaster,
  Tooltip,
  Whisper
} from 'rsuite';
import ReloadIcon from '@rsuite/icons/Reload';
import { Icon } from '@rsuite/icons';
import ScatterIcon from '@rsuite/icons/Scatter';
import ZoomoutIcon from '@rsuite/icons/Zoomout';
import UndoIcon from '@rsuite/icons/Undo';
const { hostname } = window.location;
// const hostname = '192.168.1.19';
import Port from '@/Port';
import Cropper from './Cropper';

const ImageEditModal = ({
  editOpen,
  setEditOpen,
  data123,
  setData123,
  selectedItems,
  setSelectedItems,
  deletePrevImg,
  setCurrentPage,
  fetchData,
  fileToBlob,
  resizeFile,
  base64ToBlob
}) => {
  const [originalImg, setOriginalImg] = useState('');
  const [fileInfo, setFileInfo] = useState('');
  const [editCount, setEditCount] = useState(0);
  const [isCropping, setIsCropping] = useState(false);
  const handleCropping = () => {
    setEditCount(1);
    setIsCropping(!isCropping);
  };

  const getBase64Image = imageUrl => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'Anonymous'; // Enable CORS for the image

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        try {
          resolve(canvas.toDataURL()); // Return base64
        } catch (err) {
          reject('Canvas is tainted, cannot export.');
        }
      };

      img.onerror = reject; // Reject on error
      img.src = imageUrl;
    });
  };

  useEffect(() => {
    const fetchBase64Image = async () => {
      if (selectedItems.length === 1) {
        const CoverImage = data123.find(item => item.id === selectedItems[0]).attributes.CoverImage
          .data.attributes;
        setFileInfo(`${CoverImage.url2 ?? globalIP + CoverImage.url}`);
        try {
          const base64 = await getBase64Image(`${CoverImage.url2 ?? globalIP + CoverImage.url}`);
          // console.log(base64);
          setOriginalImg(base64);
        } catch (error) {
          console.error('Error fetching base64 image:', error);
        }
      }
    };

    fetchBase64Image(); // Call the async function
  }, [selectedItems]);

  const [rotationDegrees, setRotationDegrees] = useState(0);
  const handleRotateImage = () => {
    setRotationDegrees(prevRotation => (prevRotation + 90) % 360);
  };
  const [bgChangeLoading, setBgChangeLoading] = useState(false);

  const [color1, setColor1] = useState('#FFFFFF');
  const handleColorChange = e => {
    setColor1(e.target.value);
  };

  // Function to rotate the image and return the base64 data URL
  // Function to get the rotated image as a file
  const getFile = async (imageUrl, rotationDegrees, fileName) => {
    const image = new Image();
    image.crossOrigin = 'Anonymous'; // Handle CORS issues

    return new Promise((resolve, reject) => {
      image.src = imageUrl;

      image.onload = () => {
        // Calculate the original width and height of the image
        const width = image.width;
        const height = image.height;

        // Create a canvas element
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        // Calculate the new canvas size after rotation
        const radians = (rotationDegrees * Math.PI) / 180;
        const newWidth = Math.abs(width * Math.cos(radians)) + Math.abs(height * Math.sin(radians));
        const newHeight =
          Math.abs(width * Math.sin(radians)) + Math.abs(height * Math.cos(radians));

        // Set the canvas size to the new dimensions
        canvas.width = newWidth;
        canvas.height = newHeight;

        // Translate to the center of the canvas and rotate
        ctx.translate(newWidth / 2, newHeight / 2);
        ctx.rotate(radians);

        // Draw the image, translated to the center of the canvas
        ctx.drawImage(image, -width / 2, -height / 2);

        // Convert the canvas to a Blob (image file)
        canvas.toBlob(blob => {
          if (blob) {
            const file = new File([blob], fileName, { type: 'image/jpeg' }); // Create image file with extension
            resolve(file); // Return the file
          } else {
            reject(new Error('Failed to convert canvas to blob'));
          }
        }, 'image/jpeg');
      };

      image.onerror = error => {
        console.error('Error loading image:', error);
        reject(new Error('Failed to load image'));
      };
    });
  };

  const handleSubmit = async imageUrl => {
    setBgChangeLoading(true);

    if (!imageUrl) {
      // Receive image URL from input
      alert('Please provide an image URL.');
      setBgChangeLoading(false);
      return;
    }

    if (!color1) {
      alert('Please select a color.');
      setBgChangeLoading(false);
      return;
    }

    let imageBlob = imageUrl; // Image URL passed in

    if (!(imageUrl instanceof File)) {
      // Fetch the image from the URL
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      // Create a File from the Blob (you need to specify the filename and MIME type)
      const file = new File([blob], 'image_from_url', { type: blob.type });

      imageBlob = file;
    }

    const formData = new FormData();
    formData.append('image', imageBlob);
    formData.append('color', color1);

    try {
      const response = await fetch(
        // `http://${hostname}${Port.smartsearchip}/api/change_image_background`,
        //  `http://110.227.189.169:4044/api/change_image_background`,
        `https://bgreml.growwizo.com/change_image_background/`,

        {
          method: 'POST',
          body: formData
        }
      );

      if (response.ok) {
        const newImageBlob = await response.blob();

        // Convert the resulting image Blob to Base64 and return it
        const base64Image = await blobToBase64(newImageBlob);
        setBgChangeLoading(false); // Hide loading after completion
        return base64Image; // Return base64 image URL
      } else {
        throw new Error('Failed to change background');
      }
    } catch (error) {
      console.error(error);
      setBgChangeLoading(false); // Hide loading on error
      toaster.push(
        <Message showIcon type="error">
          Something went wrong, please try again.
        </Message>,
        { placement: 'topCenter' }
      );
      return imageUrl; // Return the original image URL if error occurs
    }
  };

  // Helper function to convert blob to base64
  const blobToBase64 = blob => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob); // Convert the blob to base64
    });
  };

  // useEffect(() => {
  //   console.log('data123', data123);
  // }, [data123]);
  const [loadingMessage, setLoadingMessage] = useState('Loading');
  const handleChangeBackground = async n => {
    const updatedData = []; // To hold the updated data
    let updated = 0;

    for (let i = 0; i < data123.length; i++) {
      const item = data123[i];

      // Ensure the item is selected AND has a valid image before processing
      const imageUrl = item.attributes?.CoverImage?.data?.attributes?.url;
      if (selectedItems.includes(item.id) && updated < n && imageUrl) {
        try {
          // Await the result of handleSubmit for each item
          const newImageBase64 = await handleSubmit(
            item.attributes?.CoverImage?.data?.attributes?.url2 ?? globalIP + imageUrl
          );

          // Update the CoverImage data in a local variable
          const updatedCoverImage = {
            ...item.attributes.CoverImage,
            data: {
              ...item.attributes.CoverImage.data,
              attributes: {
                ...item.attributes.CoverImage.data.attributes,
                url2: newImageBase64 // Update the URL with the new URL
              }
            }
          };

          // Push the updated item with the new CoverImage into the updatedData array
          updatedData.push({
            ...item,
            attributes: {
              ...item.attributes,
              CoverImage: updatedCoverImage
            }
          });

          updated++; // Increment updated counter
          console.log(updated); // Log the updated data
          setLoadingMessage(`${updated}/${n}... Loading`);
        } catch (error) {
          console.error(`Error processing item ${item.id}:`, error);
        }
      } else {
        // If the item is not selected or has no image, just push the original item into updatedData
        updatedData.push(item);
      }
    }

    console.log(updatedData); // Log the updated data

    // Update the state of data123 with the modified data
    setData123(updatedData);

    return updatedData; // Return the updated data
  };

  // Function to handle saving the rotated images
  const [isrotating, setIsrotating] = useState(false);
  const [isUpdatingBG, setIsUpdatingBG] = useState(false);

  const handleSaveImageBackground = async () => {
    try {
      setIsUpdatingBG(true);

      // Fetch updated data and handle potential errors
      let updatedData;
      try {
        updatedData = await handleChangeBackground(selectedItems.length);
        console.log('updatedData', updatedData);
      } catch (error) {
        console.error('Error fetching updated data:', error);
        setIsUpdatingBG(false);
        return;
      }

      // Process and filter updated images files
      let updatedImagesFiles;
      try {
        updatedImagesFiles = await Promise.all(
          updatedData
            .filter(
              item =>
                selectedItems.includes(item.id) &&
                item.attributes?.CoverImage?.data?.attributes?.url // Ensure the product has an image
            )
            .map(async item => ({
              id: item.id,
              previousImage: item.attributes?.CoverImage?.data,
              product: item,
              newImage: await getFile(
                `${
                  item.attributes?.CoverImage?.data?.attributes?.url2 ??
                  globalIP + item.attributes?.CoverImage?.data?.attributes?.url
                }`,
                0,
                item.attributes?.CoverImage?.data?.attributes?.name
              )
            }))
        );
        console.log('updatedImagesFiles', updatedImagesFiles);
      } catch (error) {
        console.error('Error processing updated images files:', error);
        setIsUpdatingBG(false);
        return;
      }

      // Loop through each image and update it
      for (const { id, newImage, previousImage, product } of updatedImagesFiles) {
        setIsUpdatingBG(true);

        try {
          // Skip if the new image is null or undefined
          if (!newImage) {
            console.warn(`Skipping product ${id} as it has no valid image.`);
            continue;
          }

          // Delete previous image
          if (previousImage && previousImage.id) {
            await deletePrevImg(previousImage.id);
            console.log(`Previous image deleted for product ${id}`);
          }

          // Prepare form data for the new image
          const formData = new FormData();
          const fileBlob = await fileToBlob(newImage);
          // const resizedBase64 = await resizeFile(fileBlob);
          // const resizedBlob = base64ToBlob(resizedBase64, 'image/jpeg');

          formData.append('files.CoverImage', fileBlob, previousImage?.attributes.name);

          // Avoid overwriting CoverImage with null
          const innerUpdatedData = { ...product.attributes };
          delete innerUpdatedData.CoverImage;

          formData.append('data', JSON.stringify(innerUpdatedData));

          // Make the API request to update the product
          const response = await fetch(`${globalIP}/api/products/${id}`, {
            method: 'PUT',
            body: formData
          });

          if (!response.ok) {
            console.error(
              `Failed to update CoverImage for product ${id}, response status: ${response.status}`
            );
          } else {
            console.log(`Successfully updated CoverImage for product ${id}`);
          }
        } catch (error) {
          console.error(`Error updating CoverImage for product ${id}:`, error);
        }
      }
    } catch (error) {
      console.error('Error in handleSaveImageBackground:', error);
    } finally {
      setIsUpdatingBG(false);
    }
  };
  const handleSaveRotatedImage = async () => {
    setIsrotating(true);
    let updatedData = data123;
    try {
      const rotatedImagesFiles = await Promise.all(
        updatedData
          .filter(item => selectedItems.includes(item.id)) // Filter selected items
          .map(async item => ({
            id: item.id,
            previousImage: item.attributes?.CoverImage?.data,
            product: item,
            newImage: await getFile(
              `${
                item.attributes?.CoverImage?.data?.attributes?.url2 ??
                globalIP + item.attributes?.CoverImage?.data?.attributes?.url
              }`,
              rotationDegrees,
              item.attributes?.CoverImage?.data?.attributes?.name // Use the original file name
            )
          }))
      );
      // Process each rotated image file
      for (const { id, newImage, previousImage, product } of rotatedImagesFiles) {
        setIsrotating(true);
        await deletePrevImg(previousImage.id); // Delete previous image
        const formData = new FormData();
        const fileBlob = await fileToBlob(newImage);
        // const resizedBase64 = await resizeFile(fileBlob);
        // const resizedBlob = base64ToBlob(resizedBase64, 'image/jpeg');
        // console.log('previousImage.attributes.name', previousImage.attributes.name);
        // return;
        formData.append('files.CoverImage', fileBlob, previousImage.attributes.name); // Append resized Blob with original file name
        const innerupdatedData = {
          ...product.attributes // Add previous product attributes
        };
        delete innerupdatedData.CoverImage; // Avoid overwriting CoverImage with null
        formData.append('data', JSON.stringify(innerupdatedData));
        const response = await fetch(`${globalIP}/api/products/${id}`, {
          method: 'PUT',
          body: formData
        });

        if (!response.ok) console.error(`Failed to update CoverImage for product ${id}`);
        else {
          setIsrotating(false);
        }
      }
      if (selectedItems.length === 1) {
        const updatedItem = rotatedImagesFiles[0];
        const imageUrl = URL.createObjectURL(await fileToBlob(updatedItem.newImage));
        setFileInfo(imageUrl); // update preview
      }
    } catch (error) {
      console.error('Error during rotation processing:', error); // Error handling
    }
    setIsrotating(false);
  };
  const handleSaveCroppedImage = async newfileInfo => {
    try {
      setIsCropping(true);

      let updatedImagesFiles;
      try {
        updatedImagesFiles = await Promise.all(
          data123
            .filter(
              item =>
                selectedItems.includes(item.id) &&
                item.attributes?.CoverImage?.data?.attributes?.url // Ensure the product has an image
            )
            .map(async item => ({
              id: item.id,
              previousImage: item.attributes?.CoverImage?.data,
              product: item,
              newImage: await getFile(
                newfileInfo,
                0,
                item.attributes?.CoverImage?.data?.attributes?.name
              )
            }))
        );
        console.log('updatedImagesFiles', updatedImagesFiles);
      } catch (error) {
        console.error('Error processing updated images files:', error);
        setIsCropping(false);
        return;
      }
      console.log('updatedImagesFiles', updatedImagesFiles);
      // return;
      // Loop through each image and update it
      for (const { id, newImage, previousImage, product } of updatedImagesFiles) {
        setIsCropping(true);

        try {
          // Skip if the new image is null or undefined
          if (!newImage) {
            console.warn(`Skipping product ${id} as it has no valid image.`);
            continue;
          }

          // Delete previous image
          if (previousImage && previousImage.id) {
            await deletePrevImg(previousImage.id);
            console.log(`Previous image deleted for product ${id}`);
          }

          // Prepare form data for the new image
          const formData = new FormData();
          const fileBlob = await fileToBlob(newImage);
          // const resizedBase64 = await resizeFile(fileBlob);
          // const resizedBlob = base64ToBlob(resizedBase64, 'image/jpeg');

          formData.append('files.CoverImage', fileBlob, previousImage?.attributes.name);

          // Avoid overwriting CoverImage with null
          const innerUpdatedData = { ...product.attributes };
          delete innerUpdatedData.CoverImage;

          formData.append('data', JSON.stringify(innerUpdatedData));

          // Make the API request to update the product
          const response = await fetch(`${globalIP}/api/products/${id}`, {
            method: 'PUT',
            body: formData
          });

          if (!response.ok) {
            console.error(
              `Failed to update CoverImage for product ${id}, response status: ${response.status}`
            );
          } else {
            console.log(`Successfully updated CoverImage for product ${id}`);
          }
        } catch (error) {
          console.error(`Error updating CoverImage for product ${id}:`, error);
        }
      }
    } catch (error) {
      console.error('Error in handleSaveImageBackground:', error);
    } finally {
      setIsCropping(false);
    }
  };
  const handleCloseBulkEdit = () => {
    setEditOpen(false);
    setIsCropping(false);
    setCurrentPage(1);
    setRotationDegrees(0);
    setColor1('#FFFFFF');
    setSelectedItems([]);
    fetchData();
  };
  const [fetching, setFetching] = useState(false);
  useEffect(() => {
    if (!isrotating && editOpen) {
      setCurrentPage(1);

      setFetching(true);
      fetchData();
      setRotationDegrees(0);
      setFetching(false);

      toaster.push(
        <Message showIcon type="success">
          Images Rotated Successfully
        </Message>,
        { placement: 'topCenter' }
      );
    }
  }, [isrotating]);
  useEffect(() => {
    if (!isUpdatingBG && editOpen) {
      setCurrentPage(1);
      async () => {
        await fetchData();
        setRotationDegrees(0);
      };
      toaster.push(
        <Message showIcon type="success">
          Backgrounds Changed Successfully
        </Message>,
        { placement: 'topCenter' }
      );
    }
  }, [isUpdatingBG]);

  return (
    <Modal open={editOpen} onClose={handleCloseBulkEdit} backdrop="static">
      <Modal.Header>
        <Modal.Title>
          <b>Bulk Image Editing</b>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Panel>
          <FlexboxGrid justify="start" style={{ textAlign: 'center', gap: '5px' }}>
            <IconButton icon={<ReloadIcon />} disabled={isUpdatingBG} onClick={handleRotateImage}>
              Rotate
            </IconButton>
            <div
              style={{
                width: 90,
                display: 'flex',
                justifyContent: 'space-around',
                border: '1px solid grey',
                borderRadius: '7px'
              }}
            >
              <div style={{ margin: '5px' }}>
                <input
                  type="color"
                  value={color1}
                  disabled={isrotating || isUpdatingBG || bgChangeLoading}
                  onChange={handleColorChange}
                  style={{
                    marginTop: 1,
                    borderRadius: 7,
                    width: '27px',
                    cursor: 'pointer'
                  }}
                />
              </div>
              <div
                style={{
                  backgroundColor: 'rgb(216 216 219)',
                  padding: '5px',
                  paddingTop: '1px',
                  margin: '5px',
                  borderRadius: '10px',
                  cursor: 'pointer'
                }}
              >
                <Whisper
                  placement="topEnd"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>Change Background Color</Tooltip>}
                >
                  {bgChangeLoading ? (
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        paddingTop: '6px'
                      }}
                    >
                      <Loader />
                    </div>
                  ) : (
                    <Icon
                      as={ScatterIcon}
                      style={{ paddingTop: '4px' }}
                      onClick={() => handleChangeBackground(4)}
                    />
                  )}
                </Whisper>
              </div>
            </div>
            {selectedItems.length == 1 && (
              <>
                {' '}
                {
                  <Whisper
                    placement="topEnd"
                    controlId="control-id-hover"
                    trigger="hover"
                    speaker={<Tooltip>Reset</Tooltip>}
                  >
                    <IconButton
                      icon={<UndoIcon />}
                      disabled={isUpdatingBG}
                      onClick={() => {
                        if (editCount !== 0) {
                          // isCropping && handleCropping()
                          // // console.log('originalImg', originalImg);
                          setFileInfo(originalImg);
                          handleSaveCroppedImage(originalImg);
                        }
                      }}
                    ></IconButton>
                  </Whisper>
                }
                <Whisper
                  placement="topEnd"
                  controlId="control-id-hover"
                  trigger="hover"
                  speaker={<Tooltip>Crop Image</Tooltip>}
                >
                  <IconButton
                    icon={<ZoomoutIcon />}
                    disabled={isUpdatingBG}
                    onClick={handleCropping}
                  ></IconButton>
                </Whisper>
              </>
            )}
          </FlexboxGrid>
          <Divider />
          <FlexboxGrid
            justify="space-around"
            style={{ textAlign: 'center' }}
            className="datatbl-img"
          >
            {selectedItems.length == 1 ? (
              isCropping ? (
                <Stack style={{ height: '100%', width: '35%' }}>
                  <div style={{ color: 'white' }}>
                    <p> </p>
                    <br />
                    <p> </p>
                    <br />
                    <p> </p>
                    <br />
                    <p> </p>
                    <br />
                    <p> </p>
                    <br />
                    <p> </p>
                    <br />
                    <p> </p>
                    <br />
                  </div>
                  <Cropper
                    handleCropping={handleCropping}
                    imageToCrop={fileInfo}
                    croppedImage={(value: any) => {
                      setFileInfo(value);
                      handleSaveCroppedImage(value);
                    }}
                  />
                </Stack>
              ) : (
                <div style={{ height: 180, width: 180 }}>
                  <img
                    src={fileInfo}
                    width="100%"
                    height="100%"
                    style={{
                      transform: `rotate(${rotationDegrees}deg)`,
                      objectFit: 'contain'
                    }}
                  />
                </div>
              )
            ) : (
              data123
                .filter(item => selectedItems.includes(item.id))
                .slice(0, 4)
                .map(item => (
                  <FlexboxGrid.Item
                    as={Col}
                    key={item.id}
                    colspan={24}
                    md={6}
                    style={{ height: 180, width: 180 }}
                    className="data-tbl-img"
                  >
                    <img
                      style={{
                        transform: `rotate(${rotationDegrees}deg)`,
                        objectFit: 'contain',
                        transitionDelay: '200'
                      }}
                      width="100%"
                      height="100%"
                      src={`${
                        item.attributes?.CoverImage?.data?.attributes?.url2 ??
                        globalIP + item.attributes?.CoverImage?.data?.attributes?.url
                      }`}
                      alt="Image"
                      className="image-style mainimage"
                    />
                  </FlexboxGrid.Item>
                ))
            )}
          </FlexboxGrid>
          <p style={{ fontWeight: 600, marginTop: 30, color: 'var(--rs-text-secondary)' }}>
            NOTE : Refer to these images to see the changes, same changes will be applied to all
            products selected.
          </p>
        </Panel>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSaveRotatedImage}
          loading={isrotating}
          disabled={isUpdatingBG}
          appearance="primary"
          color="cyan"
        >
          Rotate All
        </Button>
        {isUpdatingBG ? (
          <>
            <Button appearance="default" active>
              {loadingMessage}
            </Button>
          </>
        ) : (
          <Button
            onClick={handleSaveImageBackground}
            disabled={isrotating}
            appearance="primary"
            color="cyan"
          >
            Update All BG
          </Button>
        )}
        <Button onClick={handleCloseBulkEdit} active appearance="default">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ImageEditModal;
